import { Controller } from '@hotwired/stimulus';

export default class SidebarNavigationController extends Controller {
  static targets = ['link', 'section'];

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.activateById(entry.target.id);
          }
        }
      },
      { rootMargin: '-25% 0px -70% 0px' }
    );

    this.sectionTargets.forEach((section) => this.observer.observe(section));
    this.activateById(this.sectionTargets[0]?.id);
  }

  disconnect() {
    this.observer.disconnect();
  }

  activate(event) {
    this.activateLink(event.currentTarget);
  }

  activateById(id) {
    const link = this.linkTargets.find((l) => l.dataset.sectionId === id);
    if (link) {
      this.activateLink(link);
    }
  }

  activateLink(activeLink) {
    this.linkTargets.forEach((link) => {
      const isActive = link === activeLink;
      link.classList.toggle('text-primary', isActive);
      link.classList.toggle('fw-bold', isActive);
      link.classList.toggle('text-black', !isActive);
    });
  }
}
